/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useRef, useState} from 'react'
import {Dropdown1} from '../../content/dropdown/Dropdown1'
import {KTIcon} from '../../../helpers'
import {StatisticsWidget3} from '../statistics/StatisticsWidget3'
import {MixedWidget3} from './MixedWidget3'
import {useThemeMode} from '../../layout/theme-mode/ThemeModeProvider'
import {getCSSVariableValue} from '../../../assets/ts/_utils'
import ApexCharts, {ApexOptions} from 'apexcharts'

type Props = {
  className: string
  color: string
  title: string
  data: any[]
}

const MixedWidget1: React.FC<Props> = ({className, color, title, data}) => {
  const chartHeight = '150px'

  const chartTitle = title.replace(/ /g, '-').toLocaleLowerCase()

  let mappedData = Object.entries(data).map(([key, value], index) => ({
    id: index + 1,
    title: key,
    value: value,
  }))

  const [xAxis, setXAxis] = useState(mappedData.slice(0, 10).map((i, index) => i.title))

  let chartSeries = [
    {
      name: 'Data',
      data: mappedData.slice(0, 10).map((i) => i.value),
    },
  ]

  const chartRef = useRef<HTMLDivElement | null>(null)
  const {mode} = useThemeMode()
  const refreshChart = () => {
    if (!chartRef.current) {
      return
    }

    const chart = new ApexCharts(chartRef.current, chartOptions(chartHeight))
    if (chart) {
      chart.render()
    }

    return chart
  }

  useEffect(() => {
    const chart = refreshChart()

    return () => {
      if (chart) {
        chart.destroy()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chartRef, mode])

  useEffect(() => {
    ApexCharts.exec(`chart-${chartTitle}`, 'updateOptions', {
      series: chartSeries,
      xaxis: {
        categories: xAxis,
      },
    })
  }, [data])

  const chartOptions = (chartHeight: string): ApexOptions => {
    const labelColor = getCSSVariableValue('--bs-gray-500')
    const borderColor = getCSSVariableValue('--bs-gray-200')

    return {
      series: chartSeries,
      chart: {
        id: `chart-${chartTitle}`,
        fontFamily: 'inherit',
        type: 'bar',
        height: chartHeight,
        toolbar: {
          show: false,
        },
        sparkline: {
          enabled: true,
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '30%',
          borderRadius: 5,
        },
      },
      legend: {
        show: false,
      },
      dataLabels: {
        enabled: true,
      },
      stroke: {
        show: true,
        width: 1,
        colors: ['transparent'],
      },
      xaxis: {
        categories: xAxis,
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        labels: {
          style: {
            colors: labelColor,
            fontSize: '12px',
          },
        },
      },
      yaxis: {
        min: 0,
        // max: 255,
        labels: {
          style: {
            colors: labelColor,
            fontSize: '12px',
          },
        },
      },
      fill: {
        type: ['solid', 'solid'],
        opacity: [0.75, 1],
      },
      states: {
        normal: {
          filter: {
            type: 'none',
            value: 0,
          },
        },
        hover: {
          filter: {
            type: 'none',
            value: 0,
          },
        },
        active: {
          allowMultipleDataPointsSelection: false,
          filter: {
            type: 'none',
            value: 0,
          },
        },
      },
      tooltip: {
        style: {
          fontSize: '12px',
        },
        y: {
          formatter: function (val) {
            return String(val)
          },
        },
        marker: {
          show: false,
        },
      },
      colors: ['#ffffff', '#ffffff'],
      grid: {
        borderColor: borderColor,
        strokeDashArray: 4,
        yaxis: {
          lines: {
            show: true,
          },
        },
        padding: {
          left: 20,
          right: 20,
        },
      },
    }
  }

  return (
    <div className={`card ${className}`}>
      {/* begin::Body */}
      <div className='card-body p-0'>
        {/* begin::Header */}
        <div className={`px-9 pt-7 card-rounded h-275px w-100 bg-${color}`}>
          {/* begin::Heading */}
          <div className='d-flex flex-stack'>
            <h3 className='m-0 text-white fw-bold fs-3'>{title}</h3>
            <div className='ms-1'>
              {/* begin::Menu */}
              <button
                type='button'
                className={`btn btn-sm btn-icon btn-color-white btn-active-white btn-active-color-${color} border-0 me-n3`}
                data-kt-menu-trigger='click'
                data-kt-menu-placement='bottom-end'
                data-kt-menu-flip='top-end'
              >
                <KTIcon iconName='category' className='fs-2' />
              </button>
              <Dropdown1 />
              {/* end::Menu */}
            </div>
          </div>
          <div ref={chartRef} className={`mixed-widget-12-chart card-rounded-bottom mt-8`} />
          {/* end::Heading */}
          {/* begin::Balance }
          <div className='d-flex text-center flex-column text-white pt-8'>
            <span className='fw-semibold fs-7'>You Balance</span>
            <span className='fw-bold fs-2x pt-1'>$37,562.00</span>
          </div>
          { end::Balance */}
        </div>

        {/* end::Header */}
        {/* begin::Items }

        <div
          className='shadow-xs card-rounded mx-9 mb-9 px-6 py-9 position-relative z-index-1 bg-body'
          style={{marginTop: '-65px'}}
        >
          {mappedData.length > 0 &&
            mappedData.map((item: any, index: number) => {
              return (
                <div key={index} className='d-flex align-items-center mb-6'>
                  <div className='symbol symbol-45px w-40px me-5'>
                    <span className='symbol-label bg-lighten'>
                      <KTIcon iconName='compass' className='fs-1' />
                    </span>
                  </div>
                  <div className='d-flex align-items-center flex-wrap w-100'>
                    
                    <div className='mb-1 pe-3 flex-grow-1'>
                      <a className='fs-5 text-gray-800 text-hover-primary fw-bold'>{item.title}</a>
                    </div>
                 
                    <div className='d-flex align-items-center'>
                      <div className='fw-bold fs-5 text-gray-800 pe-1'>{item.value}</div>
                    </div>
                   
                  </div>
                </div>
              )
            })}

          { begin::Item */}
        <div className='d-flex align-items-center mb-6'>
          {/* begin::Symbol }
            <div className='symbol symbol-45px w-40px me-5'>
              <span className='symbol-label bg-lighten'>
                <KTIcon iconName='compass' className='fs-1' />
              </span>
            </div>
            {/* end::Symbol */}
          {/* begin::Description }
            <div className='d-flex align-items-center flex-wrap w-100'>
              {/* begin::Title }
              <div className='mb-1 pe-3 flex-grow-1'>
                <a href='#' className='fs-5 text-gray-800 text-hover-primary fw-bold'>
                  Sales
                </a>
                <div className='text-gray-400 fw-semibold fs-7'>100 Regions</div>
              </div>
              {/* end::Title }
              {/* begin::Label }
              <div className='d-flex align-items-center'>
                <div className='fw-bold fs-5 text-gray-800 pe-1'>$2,5b</div>
                <KTIcon iconName='arrow-up' className='fs-5 text-success ms-1' />
              </div>
              {/* end::Label }
            </div>
            {/* end::Description }
          </div>
          {/* end::Item */}
          {/* begin::Item */}

          {/* end::Item */}
        </div>
        {/* end::Items */}
      </div>
      {/* end::Body */}
    </div>
  )
}

export {MixedWidget1}
